/**
 * The entity-type key the three lock commands send, whitelisted on the backend.
 *
 * PHP owns this string. `LockableTypeMap` keys its whitelist `'linkview'` — all
 * lower case, one word, lowercase `v` — and a client sending anything else
 * raises `UnknownLockableTypeException`, which extends nothing special, falls
 * into the generic catch in `CommandAction` and returns HTTP 500. The symptom is
 * therefore a lock that never works and reads as a crash, which is exactly the
 * reading the 409 conflict path exists to prevent.
 *
 * It is a named constant rather than an inline string at each call site so that
 * ONE assertion (`lock-command-names.test.ts`) covers every sender. An inline
 * literal repeated per call site would need the guard repeated per call site
 * too, and the one that got missed would be the one that drifts.
 */
export const LOCKABLE_ENTITY_TYPE_LINKVIEW = 'linkview';

/**
 * Second entry (Stefan, 2026-09-15: "den gleichen Lock-Mechanismus... wie bei
 * den Linkview-Kacheln"), whitelisted on the backend as `'knowledge-object'`
 * — covers BOTH content types `KnowledgeObject` carries (`document` and
 * `whiteboard`): one lock per row, not one per rendering mode.
 */
export const LOCKABLE_ENTITY_TYPE_KNOWLEDGE_OBJECT = 'knowledge-object';
